var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return (_vm.data.dataSource.data.product || []).length ? _c('MPGroup', {
    staticClass: "mp-products",
    attrs: {
      "prop": _vm.data.template.prop,
      "data": _vm.data.dataSource.data
    }
  }, [_c('MPRowSlider', {
    staticClass: "mp-products__slider",
    attrs: {
      "list": _vm.data.dataSource.data.product || []
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _vm$data$dataSource$d;

        var el = _ref.el,
            index = _ref.index;
        return [_c('GGLink', {
          attrs: {
            "to": el.path
          }
        }, [_c('div', {
          staticClass: "mp-products__product-card",
          class: {
            'mp-products__product-card_last': ((_vm$data$dataSource$d = _vm.data.dataSource.data.product) === null || _vm$data$dataSource$d === void 0 ? void 0 : _vm$data$dataSource$d.length) && index === _vm.data.dataSource.data.product.length - 1
          }
        }, [_c('div', {
          staticClass: "product-card__image-wrap"
        }, [_c('img', {
          staticClass: "product-card__image",
          attrs: {
            "src": el.image.x1,
            "srcset": el.image.x2 && ((el.image.x2) + " 2x"),
            "alt": ("Фото товара " + (el.name))
          }
        })]), _vm._v(" "), el.price ? _c('MPPrice', {
          attrs: {
            "price": el.price
          }
        }) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "product-card__name"
        }, [_vm._v(_vm._s(el.name))]), _vm._v(" "), _c('MPRatingBlock', {
          staticClass: "product-card__rate",
          attrs: {
            "rate": el.rate,
            "review-count": el.reviewCount
          }
        })], 1)])];
      }
    }], null, false, 124033971)
  })], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }